import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.ManageSubscriptionUsageMeters {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};

    .ManageSubscriptionUsageMeters-header {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};
    }

    .ManageSubscriptionUsageMeters-cards {
      display: flex;
      gap: ${spacing(3)};

      .UsageMeterCard {
        flex: 1;
      }
    }
  }
`
